/* tslint:disable */
/* eslint-disable */
/**
 * Juhsis REST Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface Trading212ApiCredentialUpdateRequest
 */
export interface Trading212ApiCredentialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof Trading212ApiCredentialUpdateRequest
     */
    'key'?: Trading212ApiCredentialUpdateRequestKeyEnum;
    /**
     * 
     * @type {string}
     * @memberof Trading212ApiCredentialUpdateRequest
     */
    'value'?: string;
}

export const Trading212ApiCredentialUpdateRequestKeyEnum = {
    ApiKey: 'ApiKey',
    ApiSecret: 'ApiSecret',
    InaApiKey: 'InaApiKey',
    InaApiSecret: 'InaApiSecret'
} as const;

export type Trading212ApiCredentialUpdateRequestKeyEnum = typeof Trading212ApiCredentialUpdateRequestKeyEnum[keyof typeof Trading212ApiCredentialUpdateRequestKeyEnum];


